module.exports = __webpack_public_path__ + "img/hand3.f0bba072.png";